export default "__VITE_ASSET__55a040c7__"